import React from "react";
import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "./RequireAuth";
import SignIn from "../auth/SignIn";
import ExpiredLinkError from "../core/error-boundary/ExpiredLinkError";
import ADPLayout from "../adp-user/APDLayout";
import ADPPersonalInfo from "../adp-user/ADPPersonalInfo";
import Submitted from "../adp-user/Submitted";

const ADPRoutes = () => {
    return (
        <Routes>
            <Route
                path="/adp-personal-info"
                element={
                    <RequireAuth>
                        <ADPLayout title="Personal Info">
                            <ADPPersonalInfo />
                        </ADPLayout>
                    </RequireAuth>
                }
            />
            <Route
                path="/adp-info-submitted"
                element={
                    <RequireAuth>
                        <ADPLayout title="">
                            <Submitted />
                        </ADPLayout>
                    </RequireAuth>
                }
            />
            <Route path="/expired-link" element={<ExpiredLinkError />} />
            <Route path="/" element={<SignIn />} />
            <Route path="*" element={<SignIn />} />
        </Routes>
    );
};

export default ADPRoutes;
